import * as React from 'react';
import {connect} from 'react-redux';
import {IconButton, WithStyles, withStyles, Dialog, DialogTitle} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import ToolsIcon from '@material-ui/icons/BuildRounded';
import AcceptIcon from '@material-ui/icons/ThumbUpRounded';
import DeclineIcon from '@material-ui/icons/ThumbDownRounded';
import SendIcon from '@material-ui/icons/Send';
import { EditPaneStyle } from './EditPane.style';
import EditPane from './EditPane';
import ShowChangesPane from './ShowChangesPane';
import AddChatMessagePane from './AddChatMessagePane';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { calculateChangedDays } from './ChangeTimePlaceCalc';
import { blueBackgroundColor, primaryColor, secondaryColor, styleColors } from 'src/main.style';
import * as UserActions from '@services/user/user.actions';
import { ISuggestion } from '@app-types/websocket/suggestion.types';
import { ChatType, IChat } from '@app-types/websocket/chat.types';
import { SUGGESTION_CHANGE_TYPES, SUGGESTION_TYPES } from '@constants/suggestionTypes';
import { DialogTop } from '@components/economy/DialogComponens';
import CloseIcon from '@material-ui/icons/CloseRounded';
import { Link } from 'react-router-dom';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import { HELP_TOPICS } from '@constants/suggestionTypes';
import CalendarHelp from './CalendarHelp';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import { ChatIcon } from '@icons/Chat';
import { WrenchIcon } from '@icons/Wrench';
import UndoIcon from '@material-ui/icons/UndoRounded';
import RedoIcon from '@material-ui/icons/RedoRounded';
import { EditPaneOption } from './EditPane.types';
import { childrenChanged } from '@helpers/calendar/suggestionCalculator';
import { applySuggestion } from '@helpers/calendar/scheduleCalculator';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  inEditMode:boolean;
  showChanges:boolean;
  showAddChatMessage:boolean;
  changedDays:IDateRange[];
  confirmDelete:boolean;
  confirmDecline:boolean;
  editSuggestion:boolean;
  showGuide:boolean;
  changedFromSuggestion:boolean;
}

interface IProps extends WithStyles<typeof EditPaneStyle> {
  userId:number;
  inEditMode:boolean;
  selectedDays:IDateRange[];
  option:EditPaneOption;
  setEditOption:(option:EditPaneOption) => void;
  // monthViewReference:React.RefObject<HTMLDivElement>;
  suggestionId:number;
  suggestions:ISuggestion[];
  chats:IChat[];
  settings?:ICalendarSetting;
  scheduleCurrent:ISchedule|undefined;
  scheduleEditBase:ISchedule|undefined;
  scheduleEditPreview:ISchedule|undefined; 
  msg:string;
  setFocusDate: (year:number,month:number,date:number) => void;
  clearSelection: () => void;
  // setResizing: (isResizing:boolean) => void;
  selectRange:(from:number,to:number, days:boolean[]) => void;
  updatePreview:(schedule:ISchedule) => void;
  updateBase:(schedule:ISchedule) => void;
  onAiSchedulePrompted:() => void;
  onAiScheduleApplied:(schedule:ISchedule) => void;
  setCalendarHighlight: (dates:IDateRange[]) => void;
  updateMsg:(msg:string, sendDirectly:boolean) => void;
  sendSuggestion:() => void;

  acceptSuggestion:(suggestionId:number) => void;
  declineSuggestion:(suggestionId:number) => void;
  deleteSuggestion:(suggestionId:number) => void;

  dismissHelpNotice:(topic:string) => void;
  unDismissHelpNotice:(topic:string) => void;
  // the wrench tip follows the header's "click or drag days" tip, so it waits until that one is dismissed
  showWrenchTip:boolean;

  cancelEdit:() => void;
  localization:"se"|"en";
  historyStep:(step:"back"|"forward") => void;
  undoAvailable:boolean;
  redoAvailable:boolean;
}

class EditFooter extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    
    let changedDays:IDateRange[] = []
    if (props.scheduleCurrent && props.scheduleEditBase && props.scheduleCurrent !== props.scheduleEditBase) {
        changedDays = calculateChangedDays(props.scheduleCurrent, props.scheduleEditBase);
        if (props.inEditMode) {
          props.setCalendarHighlight(changedDays);
        }
        
    }
    let numberOfMarkedDays:number = 0;
      
    for(const range of this.props.selectedDays) {
      const days = Math.round((range.end - range.start)/(1000*60*60*24));
      numberOfMarkedDays+=days;
    }
    this.state = {
      inEditMode:props.inEditMode,
      showChanges:false,
      showAddChatMessage:false,
      changedDays,
      confirmDelete:false,
      confirmDecline:false,
      editSuggestion:false,
      showGuide:false,
      changedFromSuggestion:this.differsFromSuggestion(props),
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (this.props.inEditMode !== prevProps.inEditMode) {
      if (this.props.inEditMode) {
        this.props.setEditOption("quickedit");
        setTimeout(() => this.setState({inEditMode: this.props.inEditMode, 
          showChanges:false,confirmDelete:false,confirmDecline:false, editSuggestion:false}), 100);
        if ( this.props.scheduleCurrent && this.props.scheduleEditBase) {
          const changedDays = calculateChangedDays(this.props.scheduleCurrent, this.props.scheduleEditBase);
          this.props.setCalendarHighlight(changedDays);
        }
      } else {
        this.props.setEditOption(undefined);
        setTimeout(() => this.setState({inEditMode: this.props.inEditMode, 
          showChanges:false,confirmDelete:false,confirmDecline:false, editSuggestion:false}), 100);  
        this.props.setCalendarHighlight([]);
      }
    }
    if (this.props.scheduleCurrent !== prevProps.scheduleCurrent || this.props.scheduleEditBase !== prevProps.scheduleEditBase) {
      let changedDays:IDateRange[] = [];
      if (this.props.scheduleCurrent === undefined || this.props.scheduleEditBase === undefined ) {
        // console.log("no changes");
      } else {
        changedDays = calculateChangedDays(this.props.scheduleCurrent, this.props.scheduleEditBase);
        let editSuggestion = this.state.editSuggestion;
        if (changedDays.length > 0 && this.props.suggestionId > 0 && editSuggestion === false && prevProps.scheduleEditBase !== undefined) {
          const alterDays = calculateChangedDays(prevProps.scheduleEditBase, this.props.scheduleEditBase);
          if (alterDays.length > 0) {
            editSuggestion = true;
          }
        }
        this.setState({changedDays,confirmDelete:false,confirmDecline:false, editSuggestion})
        if (this.props.inEditMode) {
          this.props.setCalendarHighlight(changedDays);
        }
      }
    }
    if (this.props.scheduleCurrent !== prevProps.scheduleCurrent || this.props.scheduleEditBase !== prevProps.scheduleEditBase
      || this.props.suggestionId !== prevProps.suggestionId || this.props.suggestions !== prevProps.suggestions) {
      const changedFromSuggestion = this.differsFromSuggestion(this.props);
      if (changedFromSuggestion !== this.state.changedFromSuggestion) {
        this.setState({changedFromSuggestion});
      }
    }
  }

  public render() {
    const {classes, selectedDays, suggestionId, userId, scheduleCurrent} = this.props;

    const isScheduleShared:boolean = (scheduleCurrent?(scheduleCurrent.status === SCHEDULE_TYPES.WIP?false:true):false)
    let isEraseChange = false;
    let suggestionAuthor = 0;
    let suggestion:ISuggestion | undefined;
    if (suggestionId > 0) {
      suggestion = this.props.suggestions.find((sug) => sug.id === suggestionId);
      if (suggestion) {
        suggestionAuthor = suggestion.creatorId;
        for (const change of suggestion.changes) {
          if (change.type === SUGGESTION_CHANGE_TYPES.DELETE_SCHEDULE) {
            isEraseChange = true;
          }
        }
      }
    }


    let numberOfMarkedDays:number = 0;
    
    for(const range of selectedDays) {
      const days = Math.round((range.end - range.start)/(1000*60*60*24));
      numberOfMarkedDays+=days;
    }

    let kidChanges:{before:number[],now:number[]}|undefined;
    if (this.props.scheduleEditBase && this.props.scheduleCurrent
      && childrenChanged(this.props.scheduleCurrent.data.children, this.props.scheduleEditBase.data.children)) {
      kidChanges = {before:this.props.scheduleCurrent.data.children,now:this.props.scheduleEditBase.data.children}
    }

    const numberOfChangedDays:number = this.state.changedDays.length + (kidChanges===undefined?0:1)+(isEraseChange?1:0);
    const canSend:boolean = numberOfChangedDays > 0 && this.state.changedFromSuggestion;
    
    let chatId:number|null = null;
    if (this.props.suggestionId > 0 && !this.state.editSuggestion && this.props.scheduleEditBase !== undefined) {
      for (const chat of this.props.chats) {
        if (chat.chatType === ChatType.SCHEDULE_CHAT) {
          if (chat.referenceObject && chat.referenceObject === this.props.scheduleEditBase.id) {
            chatId = chat.id;
            break;
          }
        }
      }
    }

    let helpButton:JSX.Element|undefined;
    let undoButton:JSX.Element|undefined;
    let wrenchTip:JSX.Element|undefined;

    if (suggestion && suggestion.status === SUGGESTION_TYPES.AWAITING_APPROVAL 
      && suggestion.creatorId !== userId && !this.state.editSuggestion) { // make a counter offer
      helpButton = <Button classes={{outlined:classes.buttonOutlined}}
          onClick={() => {this.setState({editSuggestion:true});
            this.props.unDismissHelpNotice(HELP_TOPICS.CLICK_EDIT_DAYS);}}
          style={this.state.inEditMode?{opacity:1, marginTop: '120px'}:{opacity:0,marginTop: '120px', pointerEvents:'none'}}>
            {tn.lang.calCounterSuggestion} 
        </Button>
    } else if (suggestion && suggestion.status === SUGGESTION_TYPES.AWAITING_APPROVAL 
      && suggestion.creatorId === userId && !this.state.editSuggestion) { // update sent suggestion
      helpButton = <div style={{display:'flex', flexDirection:'column'}}> 
        <Button classes={{outlined:classes.buttonOutlined}}
          onClick={() => {this.setState({confirmDelete:true})}}
          style={this.state.inEditMode?{opacity:1, marginTop: '64px'}:{opacity:0,marginTop: '64px', pointerEvents:'none'}}>
            {tn.lang.calDeleteSuggestion} 
        </Button>
        <Button classes={{outlined:classes.buttonOutlined}}
          onClick={() => {this.setState({editSuggestion:true});
            this.props.unDismissHelpNotice(HELP_TOPICS.CLICK_EDIT_DAYS);}}
          style={this.state.inEditMode?{opacity:1, marginTop: '16px'}:{opacity:0,marginTop: '16px', pointerEvents:'none'}}>
            {tn.lang.calAdjustSuggestion}
        </Button>
        </div>
    } else if (this.props.option === "quickedit") {
      helpButton = <div style={{ position: 'absolute',right: '20px',bottom: '100px',}}>
        <IconButton 
          style={{backgroundColor:primaryColor, width: '62px', height: '62px', boxShadow:'0px 3px 30px '+primaryColor+'+47'}}
          onClick={() => {this.setState({ editSuggestion:(this.props.suggestionId > 0)}); this.props.setEditOption("select");
            if (this.props.showWrenchTip) {
              this.props.dismissHelpNotice(HELP_TOPICS.WRENCH_TOOLS);
            }}}>
          <WrenchIcon style={{fill:'#fff'}}/>
        </IconButton>
      </div>
      if (this.props.showWrenchTip && this.state.inEditMode) {
        wrenchTip = <div className={classes.wrenchTip}
          onClick={() => this.props.dismissHelpNotice(HELP_TOPICS.WRENCH_TOOLS)}>
          <span style={{flex: 1}}>{tn.lang.calHelpWrenchTools}</span>
          <CloseIcon className={classes.wrenchTipClose}/>
          <div className={classes.wrenchTipArrow}/>
        </div>
      }
      if(this.props.undoAvailable || this.props.redoAvailable) {
        // redo goes above undo, as the send button now shares the row with undo and the wrench
        undoButton = <div style={{ position: 'absolute',left: '20px',bottom: '100px', display:'flex', flexDirection:'column-reverse'}}>
          <IconButton disabled={!(this.props.undoAvailable)}
            style={{backgroundColor:blueBackgroundColor, width: '62px', height: '62px', /* boxShadow:'0px 3px 30px '+primaryColor+'+47' */}}
            onClick={() => {this.props.historyStep("back")}}>
            <UndoIcon />
          </IconButton>
          {this.props.redoAvailable && <IconButton 
            style={{backgroundColor:blueBackgroundColor, width: '62px', height: '62px', /* boxShadow:'0px 3px 30px '+primaryColor+'+47' */}}
            onClick={() => {this.props.historyStep("forward")}}>
            <RedoIcon />
          </IconButton>}
        </div>
      }
    } 
    



    return (<>
      <div className={classes.editBox} style={this.props.inEditMode?{}:{display:'none'}}>
        {undoButton}{helpButton}{wrenchTip}
        <div className={classes.actionFabHolder} >
          <IconButton className={classes.actionFab} 
            style={{display:((this.props.suggestionId===0 || suggestionAuthor === userId || this.state.editSuggestion)?'none':'flex')}}
            onClick={() => this.setState({confirmDecline:true})}>
            <DeclineIcon style={{fill:'#D96159', fontSize:'36px'}}/>
          </IconButton>
          <IconButton className={classes.actionFab} 
            style={{display:((this.props.suggestionId===0 || suggestionAuthor === userId || this.state.editSuggestion)?'none':'flex')}}
            onClick={() => this.props.acceptSuggestion(this.props.suggestionId)}>
            <AcceptIcon style={{fill:'#93A37C', fontSize:'36px'}}/>
          </IconButton>
          {/* hidden while the wrench tip is up, which covers it and says the same */}
          <div style={{display:(canSend || (suggestionId > 0 && !this.state.editSuggestion) || wrenchTip)?'none':'flex', position:'absolute',
              opacity: '0.33',pointerEvents: 'none'}}>
              {tn.lang.helpScheduleVeryQuick}
          </div>
        </div>
        <div className={classes.sendFabHolder}>
          <Button variant='contained' size="large"
            style={((this.props.suggestionId>0 && !this.state.editSuggestion ) || this.props.option !== "quickedit")
              ?{display:'none'}
              // visibility as well as opacity: iOS WebKit otherwise keeps painting a stale shadow once the button hides
              :{opacity:(canSend?1:0),visibility:(canSend?'visible':'hidden'),pointerEvents:(canSend?'auto':'none'),
                boxShadow:(canSend?'rgb(0 0 0 / 57%) 0px 0px 8px':'none')}}
            endIcon={<SendIcon />} 
            disabled={!canSend}
            onClick={() => this.props.sendSuggestion()}
            classes={{contained:classes.buttonContainedFAB}}>
            {isScheduleShared?tn.lang.send:tn.lang.save}
          </Button>
        </div>

        <div className={classes.actionFooter} style={this.state.inEditMode?{bottom:0}:{bottom:-50}}>
          <IconButton onClick={() => this.setState({showGuide:true})} >
              ?
          </IconButton>
          <Button disabled={numberOfChangedDays === 0} 
            variant='outlined'
            style={{backgroundColor: styleColors.transparent}}
            onClick={() => this.setState({showChanges:true})}
            endIcon={<span className={classes.editCountHighlight} style={numberOfChangedDays>0?{backgroundColor: styleColors.softYellow}:{}}>
                {numberOfChangedDays}
              </span>} 
            classes={{outlined:classes.buttonOutlined}}>
            {tn.lang.calChanges}
          </Button>
          <IconButton onClick={() => this.setState({showAddChatMessage:true})} 
            style = {{display: ((chatId!==null || !isScheduleShared )?'none':'block')}}>
            <ChatIcon style={{fill:this.props.msg.length === 0?styleColors.greyDark2:secondaryColor}}/>
          </IconButton>
          <Link  to={"/app/messages/"+chatId} style = {{display: chatId===null?'none':'block'}}>
            <IconButton>
              <ChatIcon style={{fill:secondaryColor}}/>
            </IconButton>
          </Link>

        </div>
      </div>
      <EditPane 
        selectRange={this.props.selectRange}
        localization={this.props.localization}
        clearSelectedDays={() => this.props.clearSelection()}
        selectedDays={selectedDays}
        inEditMode={this.props.inEditMode}
        open={this.props.option !== "quickedit"}
        option={this.props.option}
        setEditOption={this.props.setEditOption}
        scheduleEditBase={this.props.scheduleEditBase}
        scheduleEditPreview={this.props.scheduleEditPreview}
        updatePreview={this.props.updatePreview}
        onAiSchedulePrompted={this.props.onAiSchedulePrompted}
        onAiScheduleApplied={this.props.onAiScheduleApplied}
        suggestionId={this.props.suggestionId}
        updateBase={(schedule:ISchedule) => 
          {this.props.updateBase(schedule); this.props.clearSelection();}}
      />
      <ShowChangesPane 
        inEditMode={this.props.inEditMode}
        localization={this.props.localization}
        open={this.state.showChanges}
        close={() => {this.setState({ showChanges: false }); this.props.setCalendarHighlight(this.state.changedDays);}} 
        setFocusDate={this.props.setFocusDate}
        originalSchedule={this.props.scheduleCurrent}
        schedule={this.props.scheduleEditBase}
        changes={this.state.changedDays}
        setCalendarHighlight={this.props.setCalendarHighlight}
        kidChanges={kidChanges}
        eraseChange={isEraseChange}
      />
      <AddChatMessagePane 
        msg={this.props.msg}
        inEditMode={this.props.inEditMode}
        open={this.state.showAddChatMessage}
        updateMsg={(msg) => this.props.updateMsg(msg, (this.props.suggestionId > 0 && !this.state.editSuggestion))}
        existingSuggestion={(this.props.suggestionId > 0)}
        close={() => this.setState({showAddChatMessage:false})}
      />

      <Dialog
        open={ this.state.confirmDecline || this.state.confirmDelete}
        onClose={() => this.setState({ confirmDecline:false, confirmDelete:false})}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.calConfirmReply}</DialogTitle>
          <IconButton onClick={() => this.setState({ confirmDecline:false, confirmDelete:false})}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{padding: '8px 24px', display: 'flex', flexDirection: 'column'}}>
          {this.state.confirmDecline
            ?tn.lang.calConfirmDecline
            :tn.lang.calConfirmDelete}
        </div>
        <div style={{display: "flex", flexDirection: "column", margin: "8px 24px", padding: "8px 24px", gap: "10px"}}>
       
          <Button variant='contained' color='primary' classes={{contained:classes.buttonContained}}
            onClick={() => {
              this.props.declineSuggestion(this.props.suggestionId);
              this.setState({confirmDecline:false, confirmDelete:false});
            }}>
                  <div style={{width: "80px", margin: "4px"}}>
              {tn.lang.yes}
              </div>
          </Button>
            <Button variant='outlined' onClick={() => this.setState({ confirmDecline:false, confirmDelete:false})} 
             classes={{outlined:classes.buttonOutlined}}>
              <div style={{width: "80px", margin: "4px"}}>
 
             {tn.lang.cancel}
             </div>
            </Button>
        
        </div>
      </Dialog>
      <CalendarHelp 
        open={this.state.showGuide} 
        close={() => this.setState({showGuide:false})} 
        schedule={scheduleCurrent}
        settings={this.props.settings}/>
      </>
    );
  }

  // whether the schedule being edited differs from the opened suggestion as it was sent, so there is something new to send
  private differsFromSuggestion(props:IProps):boolean {
    if (props.suggestionId === 0 || props.scheduleCurrent === undefined || props.scheduleEditBase === undefined) {
      return true;
    }
    const suggestion = props.suggestions.find((sug) => sug.id === props.suggestionId);
    if (suggestion === undefined) {
      return true;
    }
    const sent = applySuggestion(props.scheduleCurrent, suggestion);
    if (!sent.success) {
      return true;
    }
    return calculateChangedDays(sent.schedule, props.scheduleEditBase).length > 0
      || childrenChanged(sent.schedule.data.children, props.scheduleEditBase.data.children);
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const dismissedHelpMessages:string[] = state.user.dismissedHelpNotices?state.user.dismissedHelpNotices:[];

  return {
    userId,
    showWrenchTip:dismissedHelpMessages.includes(HELP_TOPICS.CLICK_EDIT_DAYS)
      && !dismissedHelpMessages.includes(HELP_TOPICS.WRENCH_TOOLS),
    chats:state.chat.chats?state.chat.chats:[],
    suggestions:state.suggestion.suggestions?state.suggestion.suggestions:[],
    settings:state.user.calendarSettings,
  };
}

const mapDispatchToProps = {
  dismissHelpNotice:UserActions.dismissHelpNotice,
  unDismissHelpNotice:UserActions.unDismissHelpNotice,
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EditPaneStyle)(EditFooter));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/EditFooter.tsx